
import React, { Component } from 'react';
import { Checkbox } from 'antd';
import { ACCOUNT_STATUS } from '../../../../common/utils/static-data';

export class AccountStatus extends Component {

    onChange = (value) => {
        const { onChange, setAccountStatus } = this.props;
        setAccountStatus(value === 0 ? true : false)
        onChange(value);
    }
    render() {
        const { value, typeOption, editable } = this.props;
        return (
            <div className="vat-fee">
                <Checkbox disabled={!editable} checked={value === ACCOUNT_STATUS.ACTIVE} onChange={() => this.onChange(ACCOUNT_STATUS.ACTIVE)}>Active</Checkbox>
                <Checkbox disabled={typeOption === 'create_new' || !editable ? true : false} checked={value === ACCOUNT_STATUS.INACTIVE} onChange={() => this.onChange(ACCOUNT_STATUS.INACTIVE)}>Inactive</Checkbox>
            </div>
        )
    }
}